import React, {useState, useEffect} from 'react'
import { HeaderCompleto } from './Content/pages/HeaderNavegacion'
import { HeaderSimple } from './Content/pages/HeaderSimple'
import { HeaderCaja } from './Content/pages/HeaderCaja'
import { ErrorBoundary } from './Content/components/Error/ErrorBoundary'

export function Header(props){
    const {
        type,
        pageClass = 'hidden',
        rute,
        title = ""
    } = props

    const [upCP, setUpCP] = useState()
    useEffect(()=>{
        if(upCP){
        }
    },[upCP])

    return(
        type === 'complete'
            ?
                <ErrorBoundary>
                    <HeaderCompleto changeDirectionBar={setUpCP} />
                </ErrorBoundary>
            :
                type === 'cart'
                    ?
                        <ErrorBoundary>
                            <HeaderCaja rute={rute} title={title} />
                        </ErrorBoundary>

                    :
                        type === 'simple'
                            ?
                                <ErrorBoundary>
                                    <HeaderSimple pageClass={pageClass} />
                                </ErrorBoundary>
                            : null
    )
} 